import { useController, useFormContext } from "react-hook-form";
import { FormControlLabel, Switch } from "@mui/material";
import PropTypes from "prop-types";
import { componentTokens } from "@accredo/fe-shared/theme/tokens/components.js";

/**
 * A Switch component integrated with react-hook-form.
 * It automatically handles form state, registration, and error display.
 * @param {string} name - The name of the field in the form.
 * @param {string} label - The label for the switch.
 * @param {object} otherProps - Other props to pass to the MUI FormControlLabel.
 * @returns {JSX.Element}
 */
const FormSwitch = ({ name, label, disabled, ...otherProps }) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  return (
    <FormControlLabel
      control={
        <Switch
          {...field}
          checked={!!field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label={label}
      sx={{ gap: componentTokens.toggle.labelGap, marginLeft: 0 }}
      {...otherProps}
    />
  );
};

FormSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default FormSwitch;
